import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";
import localStorage from "redux-persist/lib/storage";
import workflowHistoriesSlice from "./slices/workflows/workflowHistoriesSlice";
import pendingTasksSlice from "./slices/workflows/pendingTasksSlice";
import workflowListSlice from "./slices/workflows/workflowListSlice";
import domainConfigReducer from "./slices/database/domainConfigSlice";
import menuConfigSlice from "./slices/database/menuConfigSlice";
import userCompaniesSlice from "./slices/database/userCompaniesSlice";
import companyUsersSlice from "./slices/database/companyUsersSlice";
import selectedCompanySlice from "./slices/database/selectedCompanySlice";
import userAccessDataSlice from "./slices/database/userAccessDataSlice";
import translationSlice from "./slices/database/translationSlice";
import templatesSlice from "./slices/database/templatesSlice";
import tableColumnConfigSlice from "./slices/database/tableColumnConfigSlice";
import themeSlice from "./slices/themeSlice";
import offlineSlice from "./slices/offlineSlice";

const domainConfigPersistConfig = {
	key: "domainConfig",
	storage: sessionStorage,
	whitelist: ["data"],
};

const selectedCompanyPersistConfig = {
	key: "selectedCompany",
	storage: localStorage,
	whitelist: ["data"],
};

const userAccessDataPersistConfig = {
	key: "userAccessData",
	storage: localStorage,
	whitelist: ["data"],
};

const userMenuPersistConfig = {
	key: "menuConfig",
	storage: localStorage,
	whitelist: ["data"],
};

const themePersistConfig = {
	key: "theme",
	storage: localStorage,
	whitelist: ["mode"], // Only persist mode
};

const tableColumnConfigPersistConfig = {
	key: "tableColumnConfig",
	storage: sessionStorage,
	whitelist: ["configs"],
};

const rootReducer = combineReducers({
	workflowHistories: workflowHistoriesSlice,
	pendingTasks: pendingTasksSlice,
	workflowList: workflowListSlice,
	templates: templatesSlice,
	userCompanies: userCompaniesSlice,
	companyUsers: companyUsersSlice,
	translations: translationSlice,
	userAccessData: persistReducer(userAccessDataPersistConfig, userAccessDataSlice),
	domainConfig: persistReducer(domainConfigPersistConfig, domainConfigReducer),
	selectedCompany: persistReducer(selectedCompanyPersistConfig, selectedCompanySlice),
	menuConfig: persistReducer(userMenuPersistConfig, menuConfigSlice),
	theme: persistReducer(themePersistConfig, themeSlice),
	tableColumnConfig: persistReducer(tableColumnConfigPersistConfig, tableColumnConfigSlice),
	offline: offlineSlice,
});

export default rootReducer;
